<div *ngIf="enabled$ | async" id="" class="flex items-center gap-2">
  <!--  Transcription feedback-->
  <div *ngIf="showFeedback()" class="flex items-center gap-2 text-xs">
    <ui-button
      icon="griddy-thumbs-up"
      variant="quaternary"
      size="sm"
      class="text-gray-300 hover:text-success-500"
      (onClick)="rateTranscription('like')"
      title="Transcription was accurate">
    </ui-button>
    <ui-button
      icon="griddy-thumbs-down"
      variant="quaternary"
      size="sm"
      class="text-gray-300 hover:text-error-500"
      (onClick)="rateTranscription('dislike')"
      title="Transcription had errors">
    </ui-button>
  </div>
  <!--  End transcription feedback-->

  <!--  Clear transcription-->
  <ui-button
    *ngIf="wasRecorded() && $finalText() !== ''"
    label="Clear"
    variant="link-destructive"
    size="sm"
    class="text-xs font-semibold"
    (onClick)="clear()">
  </ui-button>
  <!--  End clear transcription-->

  <!--  Microphone icon-->
  <div
    *ngIf="shouldShowButton()"
    class="newmessage-icon-button relative"
    [matTooltip]="!isMobile() ? 'Voice to text' : null"
    role="button"
    tabindex="0"
    data-element="voice-to-text"
    (click)="startRecording()">
    <!-- Microphone SVG -->
    <ui-icon icon="griddy-microphone"></ui-icon>
  </div>
  <!--  End of microphone icon-->

  <!-- Waveform -->
  <div *ngIf="isRecording()" class="flex-1 mx-3 flex items-center">
    <sbnb-waveform-simple [sessionId]="sessionId" class="w-full h-full"></sbnb-waveform-simple>
  </div>
  <!-- End Waveform -->

  <!--  Stop icon-->
  <ui-button
    *ngIf="isTranscribing() && !isLoading()"
    label="Stop"
    variant="tertiary"
    size="sm"
    class="stop-button"
    (onClick)="stopRecording()">
  </ui-button>

  <!-- Loading state -->
  <div *ngIf="isTranscribing() && isLoading() && !isInitializing()" class="flex items-center gap-2">
    <mat-spinner diameter="20"></mat-spinner>
    <span class="text-gray-600 text-sm">Working...</span>
  </div>

  <!-- Initializing state -->
  <div *ngIf="isInitializing()" class="flex items-center gap-2">
    <mat-spinner diameter="20"></mat-spinner>
    <span class="text-gray-600 text-sm">Initializing...</span>
  </div>
  <!--  End of stop icon-->
</div>
